import React from "react";
import PropTypes from "prop-types";

import { FlexDiv, Image } from "../../Atoms";

import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import { ImageBox, StyledAvatar } from "./style";

function Avatar({
  src,
  name,
  nameVariant,
  nameColor,
  highlights,
  highlightsVariant,
  highlightsColor,
  hasBoxShadow,
  flexDirection,
  className,
  height,
  width,
  hideHighlights,
}: any) {
  return (
    <StyledAvatar className={`${className} ${flexDirection}`}>
      <ImageBox
        className="image-box"
        hasBoxShadow={hasBoxShadow}
        height={height}
        width={width}
      >
        {src && <Image src={src} />}
      </ImageBox>
      <FlexDiv flexDirection="column" alignItems="flex-start" flex={1}>
        {name && (
          <Typography
            variant={nameVariant}
            color={nameColor}
            textAlign={flexDirection === "row" ? "left" : "center"}
          >
            {name}
          </Typography>
        )}
        {!hideHighlights &&
          highlights?.length > 0 &&
          highlights?.map((highlight, index) => (
            <Typography
              key={`${highlight}-${index}`}
              variant={highlightsVariant}
              color={highlightsColor}
              textAlign={flexDirection === "row" ? "left" : "center"}
            >
              {highlight}
            </Typography>
          ))}
      </FlexDiv>
    </StyledAvatar>
  );
}

Avatar.propTypes = {
  nameVariant: PropTypes.string,
  nameColor: PropTypes.string,
  highlightsVariant: PropTypes.string,
  highlightsColor: PropTypes.string,
  hasBoxShadow: PropTypes.bool,
  flexDirection: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  hideHighlights: PropTypes.bool,
};

Avatar.defaultProps = {
  nameVariant: "label3",
  nameColor: theme.colorsV2.blueGray.shade_900,
  highlightsVariant: "label4",
  highlightsColor: theme.colorsV2.blueGray.shade_500,
  hasBoxShadow: false,
  flexDirection: "column",
  height: "56px",
  width: "56px",
  hideHighlights: false,
};

export default Avatar;
